import { AddToDataset } from '@solinkcorp/agent/AgentsPage/AgentOverview/AddToDataset';
import {
  Sheet,
  SheetContent,
  SheetHeader,
  SheetTitle,
} from '@solinkcorp/solink-ui/components/Sheet';
import { StableHeightSuspense } from '@solinkcorp/solink-ui/components/StableHeightSuspense';
import { type FC } from 'react';

interface AddToDatasetSheetProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  eventId: string;
}

export const AddToDatasetSheet: FC<AddToDatasetSheetProps> = ({ open, onOpenChange, eventId }) => {
  return (
    <Sheet open={open} onOpenChange={onOpenChange}>
      <SheetContent
        side="right"
        className="tw flex w-[480px] !max-w-full flex-col text-foreground-primary"
      >
        <div className="flex min-h-0 flex-1 flex-col">
          <StableHeightSuspense>
            <SheetHeader>
              <SheetTitle>Add to Dataset</SheetTitle>
            </SheetHeader>
            <div className="flex flex-col gap-4 overflow-y-auto px-6 pb-6 pt-4">
              <AddToDataset
                item={{ type: 'eventid', eventId }}
                onSuccess={() => onOpenChange(false)}
              />
            </div>
          </StableHeightSuspense>
        </div>
      </SheetContent>
    </Sheet>
  );
};
